import { render, staticRenderFns } from "./OrdersValue.vue?vue&type=template&id=16c46ec4&scoped=true&"
import script from "./OrdersValue.vue?vue&type=script&lang=js&"
export * from "./OrdersValue.vue?vue&type=script&lang=js&"
import style0 from "./OrdersValue.vue?vue&type=style&index=0&id=16c46ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c46ec4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
installComponents(component, {
  VChip,
})
